import { CdkStepLabel } from '@angular/cdk/stepper';
import { Directive } from '@angular/core';

@Directive({
  selector: '[nStepLabel]',
})
export class NStepLabelDirective extends CdkStepLabel {}
